import { compose } from 'recompose';
import { connect } from 'react-redux';
import WithBookNoPayQuery from '../../hoc/WithBookNoPayQuery';
import * as barberSelectors from '../../barbers/selectors';
import * as reservationSelectors from '../../reservation/selectors';
import * as servicesSelectors from '../../services/selectors';
import WithKioskProp from '../../hoc/WithKioskProp';
import WithTimeWaitingList from '../../hoc/WithTimeWaitingList';
import withRouteParameters from './withRouteParameters';
import { ANY_BARBER } from '../../constants';

export default compose(
  WithTimeWaitingList,
  WithKioskProp,
  withRouteParameters,
  WithBookNoPayQuery,
  connect(
    (state, ownProps) => {
      // tip is calculated based on cost with taxes
      const tipEnabled = barberSelectors.getTipEnabledForBarber(state, ownProps.barberRoute) && !ownProps.kiosk;
      let activeTip = tipEnabled ? reservationSelectors.getActiveTip(state) : null;
      let tipAmount = reservationSelectors.getActiveTipAmount(state);
      let fees = state.reservation.get('fees');
      const serviceCost = reservationSelectors.getServicesCost(state);
      const taxes = reservationSelectors.getTaxBreakdownAmount(state);
      const taxBreakdown = reservationSelectors.getTaxBreakdown(state);
      const discount =
        reservationSelectors.getPromoAmount(state, serviceCost, taxes) + reservationSelectors.getGiftCardAmount(state);
      const membershipDiscount = reservationSelectors.getTotalMembershipDiscount(state);
      let totalAmount = reservationSelectors.getTotalAmount(state);

      // hide booking fee and tip in new payment modal when reserving and paying
      if (ownProps.action === 'reserveAndPay') {
        fees = 0;
        tipAmount = 0;
        activeTip = null;
        totalAmount = reservationSelectors.getTotalAmountWithoutTipAndFees(state);
      }

      if (ownProps.barberRoute === ANY_BARBER && ownProps.timeWaitingList) {
        totalAmount = Math.max(0, totalAmount - tipAmount);
        tipAmount = 0;
      }

      return {
        servicesNamesShort: servicesSelectors.getServiceNameShort(state, ownProps.serviceId),
        servicesNamesLong: servicesSelectors.getServiceNameLong(state, ownProps.serviceId),
        taxes,
        fees,
        totalAmount,
        costWithTaxes: serviceCost + taxes,
        tipEnabled,
        serviceCost,
        remainingGiftCardBalance: reservationSelectors.getGiftCardBalance(state),
        discount,
        membershipDiscount,
        activeTip,
        tipAmount,
        taxBreakdown,
        isGiftCardDiscount: !!reservationSelectors.getGiftCardAmount(state),
        isCoveredByDiscount: !!discount && totalAmount === 0,
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/withCost.js